module.exports = __webpack_public_path__ + "static/modal-d43fd567b1dcf6737a97f160fe5db451.svg";